import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { LuFileCheck } from 'react-icons/lu'
import { LuFileX } from 'react-icons/lu'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const accepted = properties?.accepted === 'true'
  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        <Indicator className={accepted ? 'accepted' : 'denied'}>
          {accepted ? <LuFileCheck /> : <LuFileX />}
          <span className='txt'>{properties?.text}</span>
        </Indicator>
      </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 2rem;
`
const Indicator = styled(GlobalVariables)`
  text-align: center;
  padding: 0.4rem 0.8rem 1rem;
  border-top: 3px solid var(--red-main);
  color: var(--red-main);
  &.accepted {
    border-top: 3px solid var(--green-main);
    color: var(--green-main);
  }
  svg {
    font-size: 2.4rem;
    line-height: 2.8rem;
    top: 5px;
    position: relative;
    margin-right: 0.6rem;
  }
  span {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2rem;
  }
`
export default MainComponent
